<template>
    <section class="auth-frame">
        <section class="auth">
            <div class="auth-body">
                <form class="auth-elements" @submit.prevent="submit">
                    <h1 class="visuallyhidden">Reset Password</h1>
                    <div class="auth-logo"/>

                    <template v-if="step == 0">
                        <app-alert
                            v-if="errorMessage"
                            type="error"
                            class="auth-error">{{ errorMessage }}</app-alert>
                        <p>Enter a new password below to finish the reset process.</p>
                        <label class="has-float-label">
                            <input
                                v-model="credentials.password"
                                type="password"
                                placeholder=" "
                                aria-required="true">
                            <span>Password</span>
                        </label>
                        <label class="auth-form-row">
                            <app-button :loading="loading" type="primary" native-type="submit">Submit</app-button>
                        </label>
                        <router-link :to="{ name: 'login' }">Back to Login</router-link>
                    </template>

                    <template v-if="step == 1">
                        <app-alert v-if="successMessage" type="success">{{ successMessage }}</app-alert>
                        <app-button type="primary" @click="goToLogin">Login</app-button>
                    </template>
                </form>
            </div>
            <div class="auth-graphic"/>
        </section>
    </section>
</template>

<script>
import { first } from '@/utilities'
import { mapActions } from 'vuex'
export default {
    name: 'reset-password',
    components: {},
    props: ['uuid'],
    head: {
        title: {
            inner: 'Reset Password'
        }
    },
    data() {
        return {
            loading: false,
            errorMessage: null,
            successMessage: null,
            step: 0,
            credentials: {
                password: ''
            }
        }
    },
    methods: {
        ...mapActions(['resetPassword']),
        submit() {
            this.loading = true

            this.credentials.token = this.uuid
            this.resetPassword(this.credentials)
                .then(response => {
                    this.step = 1
                    this.loading = false
                    this.successMessage = response.data
                })
                .catch(({ messages }) => {
                    this.loading = false
                    this.errorMessage =
                        first(messages) ||
                        'There was an error with your request.'
                })
        },
        goToLogin() {
            this.$router.push({ name: 'login' })
        }
    }
}
</script>

<style lang="stylus">
@import '../../../stylus/variables'

.alert-success
    margin-bottom: 15px
</style>
